<template>
  <div class="form-quizz-questions-component">
    <draggable v-model="sortedQuestions" handle=".handle" group="questions">
      <form-quizz-question-item
        v-for="(question, i) in sortedQuestions"
        :key="`q-${i}`"
        :item="question"
        :form="form"
        :is-final-quiz="isFinalQuiz"
        :is-all-saved="is_all_saved"
        @delete="submitDeleteQuestion"
        @remove="remove"
        @update="refresh"
        :index="i"
      />
    </draggable>

    <div
      v-if="!sortedQuestions.length"
      class="container centralize-row text-center pt-5 mb-6"
    >
      <div class="row justify-content-center py-9">
        <div class="col-lg-4 d-flex flex-column align-items-center gap-4">
          <h2 class="text-semibold">Ainda não há nada aqui</h2>
          <img src="@/assets/images/no-content.svg" />
          <hr class="w-100 m-0" />
          <h2>Talvez você precise</h2>
          <snow-button
            text="Adicionar questão"
            icon="ph ph-plus"
            @click="add"
          />
        </div>
      </div>
    </div>

    <button-add-question v-else @click="add" text="Adicionar questão" />
  </div>
</template>

<script>
import ButtonAddQuestion from "@/components/ButtonAddQuestion";
import draggable from "vuedraggable";
import FormQuizzQuestionItem from "./FormQuizzQuestionItem";

export default {
  components: { draggable, FormQuizzQuestionItem, ButtonAddQuestion },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    isFinalQuiz: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "form",
    event: "change"
  },
  data() {
    return {
      questions: []
    };
  },
  computed: {
    is_all_saved() {
      return this.form.questions.reduce((ac, cur) => ac && !!cur.id, true);
    },
    sortedQuestions: {
      get() {
        return [...this.form.questions]
          .filter(q => !q.deleted)
          .sort((a, b) => a.sort - b.sort);
      },
      set(value) {
        for (let i in this.form.questions) {
          for (let j in value) {
            if (this.form.questions[i].id === value[j].id) {
              this.form.questions[i].sort = j;
            }
          }
        }
        this.saveOrder();
      }
    },
    is_all_question_with_alternatives() {
      return [...this.form.questions].reduce(
        (ac, cur) => ac && cur.answer_options && cur.answer_options.length > 0,
        true
      );
    }
  },
  methods: {
    refresh() {
      this.$emit("update");
    },
    async saveOrder() {
      const error_index = undefined;
      try {
        const action =
          this.$route.name == "product-members-module-quizz-final-edit"
            ? "membersQuizzes/putFinal"
            : "membersQuizzes/put";

        await this.$store.dispatch(action, this.form);
      } catch (e) {
        error_index = i;
      }

      if (error_index) {
        this.$message.error(
          `Não foi possível salvar a pergunta ${error_index + 1}`
        );

        return;
      }

      this.refresh();
    },
    success(response) {
      this.form.questions = response.data.results;
    },
    add() {
      this.form.questions = [
        ...this.form.questions,
        {
          title: "",
          answer_options: []
        }
      ];
    },
    remove(index) {
      this.form.questions = this.form.questions.filter((_, i) => i !== index);
    },
    submitDeleteQuestion(index) {
      const form = { ...this.form };

      const nonDeleted = form.questions.filter(q => !q.deleted);

      nonDeleted[index].deleted = true;

      const index_to_change_in_root_array = form.questions.findIndex(
        q => q.title == nonDeleted[index].title
      );

      form.questions[index_to_change_in_root_array] = nonDeleted[index];

      this.$emit("change", { ...form });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-quizz-questions-component {
  .btn {
    .icon-angle-left {
      font-size: 20px;
    }
  }

  ::v-deep .fa-solid.fa-file-pen {
    font-size: 16px;
    margin-right: -8px;
  }
}
</style>
